import { Injectable, Type } from '@angular/core';
import { Field } from '@shared/models';
import { FormAlertComponent } from '@shared/components/forms/components/form-alert/form-alert.component';
import { FormButtonGroupComponent } from '@shared/components/forms/components/form-button-group/form-button-group.component';
import { FormButtonComponent } from '@shared/components/forms/components/form-button/form-button.component';
import { FormCheckboxListComponent } from '@shared/components/forms/components/form-checkbox-list/form-checkbox-list.component';
import { FormCheckboxComponent } from '@shared/components/forms/components/form-checkbox/form-checkbox.component';
import { FormDateComponent } from '@shared/components/forms/components/form-date/form-date.component';
import { FormFilePathComponent } from '@shared/components/forms/components/form-file-path/form-file-path.component';
import { FormFileComponent } from '@shared/components/forms/components/form-file/form-file.component';
import { FormHeadingComponent } from '@shared/components/forms/components/form-heading/form-heading.component';
import { FormInputGroupComponent } from '@shared/components/forms/components/form-input-group/form-input-group.component';
import { FormInputComponent } from '@shared/components/forms/components/form-input/form-input.component';
import { FormLinkComponent } from '@shared/components/forms/components/form-link/form-link.component';
import { FormParagraphComponent } from '@shared/components/forms/components/form-paragraph/form-paragraph.component';
import { FormRadioListComponent } from '@shared/components/forms/components/form-radio-list/form-radio-list.component';
import { FormSelectComponent } from '@shared/components/forms/components/form-select/form-select.component';
import { FormTextareaComponent } from '@shared/components/forms/components/form-textarea/form-textarea.component';
import { FormTimeComponent } from '@shared/components/forms/components/form-time/form-time.component';
import { FormToggleComponent } from '@shared/components/forms/components/form-toggle/form-toggle.component';

@Injectable({ providedIn: 'root' })
export class FormListService {
  public getComponents() {
    const components: Record<string, Type<Field>> = {
      button: FormButtonComponent,
      buttongroup: FormButtonGroupComponent,
      input: FormInputComponent,
      inputgroup: FormInputGroupComponent,
      number: FormInputComponent,
      file: FormFileComponent,
      filepath: FormFilePathComponent,
      password: FormInputComponent,
      email: FormInputComponent,
      date: FormDateComponent,
      time: FormTimeComponent,
      textarea: FormTextareaComponent,
      checkbox: FormCheckboxComponent,
      checkboxlist: FormCheckboxListComponent,
      radiolist: FormRadioListComponent,
      select: FormSelectComponent,
      link: FormLinkComponent,
      toggle: FormToggleComponent,
      heading: FormHeadingComponent,
      paragraph: FormParagraphComponent,
      alert: FormAlertComponent,
    };

    return components;
  }
}
